<script lang="ts">
  import Button from '$components/elements/Button.svelte';

  export let buttonText: string;
  export let href: string | undefined = undefined;
  export let backgroundColor: string | undefined = undefined;
</script>

<div class="support-us-box" style="--background-color: {backgroundColor}">
  <p class="support-us-box__title">
    <slot />
  </p>
  <Button color="#C99E77" icon="arrow-right" iconColor="#fff" type="normal" {href}
    >{buttonText}</Button
  >
</div>

<style lang="scss">
  .support-us-box {
    width: 100%;
    max-width: 625px;
    height: 100%;
    min-height: 380px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 100px 75px;

    background-color: var(--background-color);
    border-radius: 13px;

    &__title {
      font-weight: 700;
      font-size: 28px;
      text-align: center;
      color: $color-dark-gray;
    }
  }

  @media screen and (max-width: 1000px) {
    .support-us-box {
      min-width: 328px;
      min-height: 180px;
      padding: 43px 25px;

      gap: 24px;

      &__title {
        font-size: 18px;
      }
    }
  }
</style>
